<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BDDzEG/tc-custom/9781504065979.jpg?1708811039002" alt="This image is the cover for the book End of Mr. Garment, The Walter Ghost Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">End of Mr. Garment, The Walter Ghost Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A novelist meets an abrupt end in this cozy mystery by the author of <i>Dead Man Inside</i>.</b></p><p>Stephen Garment, one of England’s greatest writers, is late for an engagement at the fashionable Chicago home of Mr. and Mrs. Howland Kimbarks. Fortunately, he’s just outside in a taxicab. <i>Un</i>fortunately, he’s dead . . .</p><p>Garment was alive when he entered the cab, and the doors were not opened. Somehow, he managed to arrive at his destination with a knife in his heart.</p> The authorities are unable to find any leads, and the case sits quietly until word gets to brilliant amateur detective Walter Ghost. Ghost knows his way around puzzling crimes like this one. And with Ghost on the case, the killer can be certain they won’t miss their day in court . . 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vincent Starrett
      </h2>
      
      <p class="authorDescription body article">Vincent Starrett (1886&ndash;1974) was a Chicago journalist who become one of the world&rsquo;s foremost experts on Sherlock Holmes. A books columnist for the <I>Chicago Tribune</I>, he also wrote biographies of authors such as Robert Louis Stevenson and Ambrose Bierce. A founding member of the Baker Street Irregulars, Starrett is best known for writing <I>The Private Life of Sherlock Holmes</I> (1933), an imaginative biography of the famous sleuth.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MysteriousPress.com/Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c1890036